export default __webpack_public_path__ + "static/media/IIDEC_WEB_BANNER_POLOS.8f0372c2.jpg";